<template>
  <div class="m-portlet">
    <div class="m-portlet__head mt-3">
      <div class="m-portlet__head-caption">
        <div class="m-portlet__head-title">
          <h3 class="m-portlet__head-text">
            Finances
          </h3>
        </div>
      </div>
    </div>
    <div class="m-portlet__body">
      <div class="row">
        <div class="col-12">
          <loader v-if="!users"></loader>
          <div v-if="users" v-for="user in users">
            <div class="row client light-hover py-2" :class="{'border-top' : user.user.name === 'TOTAL'}">
              <div class="col client-name-col align-self-center">
                <span class="m-badge m-badge--success m-badge--dot"></span>
                <span style="font-weight: bolder; font-size: 1.25rem;">{{ user.user.name }}</span>
              </div>
              <div class="col text-right">
                <b style="font-size: 1.25rem; color: #575962;">
                  {{ user.generated_money.toFixed(2) }} €
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'startDate',
      'endDate'
    ],
    data() {
      return {
        users: null,
        currencies: null
      }
    },
    created() {
      this.axios.get('currencies').then(response => {
        this.currencies = response.data
        this.fetchData()
      })
    },
    watch: {
      startDate: function () {
        this.onRangeChanged()
      },
      endDate: function () {
        this.onRangeChanged()
      }
    },
    methods: {
      onRangeChanged() {
        this.fetchData()
      },
      fetchData() {
        this.axios.get('reports/financial/engineerReport', {params: {startDate: this.startDate, endDate: this.endDate}}).then(response => {
          this.users = response.data
        }).catch(error => {
        })
      },
    }
  }
</script>
<style>
  .border-top {
    border-top: 1px solid black;
  }
</style>



// WEBPACK FOOTER //
// src/views/reports/ResourceFinancial.vue